import Emitter from "./Emitter";

export default class Logout extends Emitter {
    constructor(gb) {
        super(gb);
    }

    EXCITE_handler() {
        this.emitParent({ "event": "showHome" });
    }

    MGS_handler(payload) {
        this.emitParent('{"Name" : "logout","Origin" : "embeddedgame"}');
    }

    _default() {
        if (this.gb.queryParams && this.gb.queryParams.logoutUrl !== undefined)  {
            window.top.location = decodeURIComponent(this.gb.queryParams.logoutUrl);
        } else {
            this.emitParent({ wpgaction: "logout.parent" });
            this.emitTop({ wpgaction: "logout" }); (this.gb.utils.isIframe === true)
        }
    }
}
